import HospitalInEngLogDBServices from "../../db-services/hospitalInEngLogDBService";
import { ILogResponseModel } from "../types";


class HospitalInEngLogService {
    private dbService;

    constructor() {
        this.dbService = new HospitalInEngLogDBServices();
    }

    async getAllLogs(dayAgo: number): Promise<ILogResponseModel[]> {
        try {
            const response = await this.dbService.getAll(dayAgo)
            return response
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

}


export default HospitalInEngLogService;
